/**
 * Classifies a tool name by where it actually executes.
 *
 * Display-only: the backend returns raw tool names and does not care about the
 * split. Keep FRONTEND_TOOL_NAMES in sync with the tools registered in
 * `src/components/copilot/actions/CopilotFrontendTools.tsx` — a name missing
 * here is merely labelled "gateway", nothing breaks.
 */
export type ToolSurface = "frontend" | "backend" | "gateway";

const FRONTEND_TOOL_NAMES = new Set([
  "navigate_to_page",
  "open_priority_detail",
  // Retired (create now goes through the chat); kept so past analytics rows still read "Browser".
  "open_create_priority",
]);

/** OneClaw exposes the OneThing MCP server's tools under this prefix. */
const BACKEND_TOOL_PREFIX = "onething__";

export function toolSurface(toolName: string): ToolSurface {
  if (FRONTEND_TOOL_NAMES.has(toolName)) return "frontend";
  if (toolName.startsWith(BACKEND_TOOL_PREFIX)) return "backend";
  return "gateway";
}

export const SURFACE_LABEL: Record<ToolSurface, string> = {
  frontend: "Browser",
  backend: "OneThing API",
  gateway: "Gateway",
};

/** Strips the MCP prefix so the table reads `create_priority`, not `onething__create_priority`. */
export function displayToolName(toolName: string): string {
  if (!toolName) return "(unknown)";
  return toolName.startsWith(BACKEND_TOOL_PREFIX)
    ? toolName.slice(BACKEND_TOOL_PREFIX.length)
    : toolName;
}
